import React, { useEffect, useState } from "react";
import "../../assets/style/pageStyle/postNews.scss";
import { Col, Row, Tabs } from "antd";
import TableNews from "../../components/common/Table/TableNews";
import { useDispatch, useSelector } from "react-redux";
import {
  resetState,
  resetStatusNews,
  setOpenModalGetLogNews,
} from "../../services/slice/NewsSlice";
import { newsSelector } from "../../services/selector/index.";
import Notify from "../../components/common/Notify";
import TranslateText from "../../components/common/TranslateText";
import { useTranslation } from "react-i18next";
import TableConfigPageOneNews from "../../components/common/Table/TableConfigPageOneNews";
import ModalGetLog from "../../components/common/Modal/getLog/ModalGetLog";
import ModalPostNews from "../../components/common/Modal/add/ModalPostNews";
const PostNews = () => {
  const dispatch = useDispatch();
  const newsState = useSelector(newsSelector);
  useEffect(() => {
    return () => dispatch(resetState());
  }, []);
  const { t } = useTranslation();
  const [tab, setTab] = useState(1);
  const handleChangeTabs = (key) => {
    setTab(key);
  };
  return (
    <div className="wrapperPostNews containerContentPage">
      <Notify
        type={newsState.typeNotify}
        isNotify={newsState.isNotify}
        reset={resetStatusNews}
        title={"Bkav Pro"}
        content={newsState.msg}
      />
      {newsState.isOpenModalGetLogNews && (
        <ModalGetLog
          data={newsState.dataLog}
          total={newsState.dataLog.length}
        />
      )}
      {newsState.isOpenModalAddNews && (
        <ModalPostNews title={"Thêm mới tin tức an ninh"} />
      )}
      {newsState.isOpenModalGetLogNews && (
        <ModalGetLog
          open={newsState.isOpenModalGetLogNews}
          setOpen={setOpenModalGetLogNews}
          data={newsState.dataLog}
        />
      )}
      <div className="headerPage">
        <h2 className="title">
          <TranslateText text={"Tin tức an ninh"} />
        </h2>
      </div>

      <Row className="tableContent">
        <Tabs
          key={1}
          activeKey={tab}
          onChange={handleChangeTabs}
          items={[
            {
              label: t("Tất cả"),
              key: 1,
              children: <TableNews />,
            },
            {
              label: t("Trang 1"),
              key: 2,
              children: <TableConfigPageOneNews />,
            },
          ]}
        />
      </Row>
    </div>
  );
};

export default PostNews;
